<template>
  <div id="userAccountSet">

    <Picker v-if="showPiker" @picker-event="pickerEvent"  ></Picker>
    <mt-datetime-picker
      ref="picker"
      type="date"
      :startDate = "startDate"
      :endDate = "endDate"
      @confirm="handleConfirm"
      v-model="pickerValue">
    </mt-datetime-picker>
    <mt-header title="个人信息" style="height: 50px" class="topHeard">
      <router-link to="/userAccountSet" slot="left">
        <mt-button>
          <img src="../../../assets/icon/back.png" height="auto" width="8px" slot="icon" style="margin-left: 12px">
        </mt-button>
      </router-link>
      <mt-button slot="right" style="color: #666666" @click="saveInfo">保存</mt-button>
    </mt-header>
    <hr style="height: 1px;background-color: #d8d8d8;"/>

    <div class="defaultAccountSet-cell  defaultAccountSet-cell1">
      <div class="cell-leftTitle cell-leftTitle1">头像</div>
      <div class="cell-rightView cell-rightView1">

        <!--<img :src="userIcon" id="previewer" style="border-style: none;" @click="uploadImg"/>-->
        <img :src="userIcon" id="defaultAccountSet-userIcon" style="border-style: none;" @click="uploadImg"/>
        <input class="upload-open-photo" accept="image/*" type="file" id="filechooser" v-on:change="btnUploadFile($event)"/>
      </div>
    </div>
    <hr class="userAccountSet-sparator"/>

    <div class="defaultAccountSet-cell">
      <div class="cell-leftTitle">昵称</div>
      <div class="cell-rightView">
        <input type="text"
               style="color:#191919"
               v-model="userName"
               class="userAccountSet-textfield"/>
      </div>

    </div>
    <hr class="userAccountSet-sparator"/>

    <div class="defaultAccountSet-cell" @click="birthdayEvent">
      <div class="cell-leftTitle">生日</div>
      <div class="cell-rightView">
        {{userBirthday}}
      </div>
    </div>
    <hr class="userAccountSet-sparator"/>

    <div class="defaultAccountSet-cell">
      <div class="cell-leftTitle">性别</div>
      <div class="cell-rightView sex-list">
        <li>
					<span class="radio-group">
						<input type="radio" id="man" class="input-radio" v-model="userSex" value="男">
						<span class="icon-radio"></span>
					</span>
          <label for="man">男</label>
        </li>
        <li>
					<span class="radio-group">
						<input type="radio" id="women" class="input-radio" v-model="userSex" value="女">

						<span class="icon-radio"></span>

					</span>
          <label for="women">女</label>
        </li>

      </div>
    </div>
    <hr class="userAccountSet-sparator"/>

    <div class="defaultAccountSet-cell" @click="cityEvent">
      <div class="cell-leftTitle">所在城市</div>
      <div class="cell-rightView">
        <span>{{userCurrentCity}}</span>
        <img src="../../../assets/icon/location.png" id="defaultAccountSet-cell-location"/>
      </div>
    </div>
    <hr class="userAccountSet-sparator"/>

  </div>


</template>

<script>
  import Picker from './cityPicker'
  import api from '../../../api/mine/api.mine'
  import commonApi from '../../../api/common/api.common'
  export default {
    components: {
      Picker
    },
    computed: {
      startDate () {
        var date = new Date()
        date.setUTCFullYear(1900)
        date.setUTCMonth(0)
        date.setUTCDate(1)
        return date
      },
      endDate () {
        var date = new Date()
        return date
      }
    },
    mounted () {
      var date = new Date()
      date.setFullYear(1991)
      date.setDate(1)
      date.setMonth(0)
      this.pickerValue = date

      this.userName = this.$store.state.user.nickName
      this.userIcon = this.$store.state.user.avatar
      this.userBirthday = this.$store.state.user.birthday
      this.userSex = this.$store.state.user.sex
      this.userCurrentCity = this.$store.state.user.provinceName + '  ' + this.$store.state.user.cityName

      var self = this
      // commonApi.getAllCity({},function (respond) {
      //   var data = respond.body.data
      //   self.cityDatas = data

      // })

      commonApi.getUserInfo({},function (successRsp) {
        self.$store.dispatch('setUserLogin',successRsp.body.data)
        self.userName = self.$store.state.user.nickName
        self.userIcon = self.$store.state.user.avatar
        self.userBirthday = self.$store.state.user.birthday
        self.userSex = self.$store.state.user.sex
        self.userCurrentCity = self.$store.state.user.provinceName + '  ' + self.$store.state.user.cityName
      },function () {

      },false)
    },
    data () {
      return {
        userName:'',
        userIcon:'',
        userBirthday:'',
        userSex:'',
        userCurrentCity:'',
        fileData: Object,
        showPiker: false,
        pickerValue: '',
        currentProvinceID: 0,
        cityDatas: {},
        addressCity: undefined,
        urlbase: {}
      }
    },
    methods: {
      getStr (str) {
        str ='00000'+str;
        return str.substring(str.length-2,str.length);
      },
      cityEvent () {
        console.log('????')
        this.showPiker = true
      },
      handleConfirm (sender) {
        this.userBirthday = sender.getFullYear() + '/' + (this.getStr(sender.getMonth() + 1)) + '/'+ this.getStr(sender.getDate())
        console.log(this.userBirthday)
        console.log(this.pickerValue)
      },
      birthdayEvent () {
        this.$refs.picker.open()
      },
      saveInfo () {


//        if (this.userName === undefined || this.userName.length === 0) {
//          this.utils.alert('请输入您的昵称')
//          return
//        }
//
//        if (this.userBirthday === undefined || this.userBirthday.length === 0) {
//          this.utils.alert('请选择您的生日')
//          return
//        }

//        if (this.userSex === undefined || this.userSex.length === 0) {
//          this.utils.alert('请选择您的性别')
//          return
//        }

//        if (this.userCurrentCity === undefined || this.userCurrentCity.length === 0) {
//          this.utils.alert('请选择您所在的城市')
//          return
//        }

        var self = this

        if (this.urlbase.length > 10) {
          var data = new FormData();
          var base64 = this.urlbase.slice(this.urlbase.indexOf('base64,')+7,this.urlbase.length)
          data.append('file', this.base64toBlob(base64,'jpeg'));

          api.uploadUserIcon( data, function (respond) {
            var data = {}
            data.nickName = self.userName
            if (self.userSex === '男') {
              data.sex = 1
            }
            else if (self.userSex === '女'){
              data.sex = 2
            }
            else {
              data.sex = 0
            }

            if ( self.userBirthday ) {
              data.birthday = self.userBirthday.replace(/[\/]/g, "-")
            }

            if (self.addressCity !== undefined){
              data.cityId = self.addressCity.regionalismId
            }
            data.avatar = respond.body.data[0]['url']
            console.log(data)

            api.editUserInfo(data,function (successRespond) {
              console.log(successRespond)
              self.utils.alert('保存成功')
              self.$router.push('/userAccountSet')
            })
          },function () {
            self.utils.alert('上传头像失败，请稍后再试')
          },false)

          return
        }

        var data = {}
        data.nickName = self.userName
        if (self.userSex === '男') {
          data.sex = 1
        }
        else if (self.userSex === '女'){
          data.sex = 2
        }
        else {
          data.sex = 0
        }

        if ( self.userBirthday ) {
          data.birthday = self.userBirthday.replace(/[\/]/g, "-")
        }
        if (self.addressCity !== undefined){
          data.cityId = self.addressCity;
        }


        api.editUserInfo(data,function (successRespond) {
          console.log(successRespond)
          self.utils.alert('保存成功')
          self.$router.push('/userAccountSet')
        })

      },
      uploadImg () {

      },
      btnUploadFile(e){
        //获取图片
        var  self = this;
        var filechooser = document.getElementById('filechooser');
        var previewer = document.getElementById('defaultAccountSet-userIcon');
        var that = e.target;
        var files = that.files;
        var file = files[0];
        console.log(e.target.result)
        //判断拍摄方向，
//        EXIF.getData(file,function(){
//          self.orientation=EXIF.getTag(this,'Orientation');
//        });
        self.fileData = file;
//        previewer.src = e.target.result
        // 接受 jpeg, jpg, png 类型的图片
        if (!/\/(?:jpeg|jpg|png)/i.test(file.type)){
          return;
        }
        var reader = new FileReader();
        reader.onload = function() {
          var result = this.result;
          var img =  new Image();
          //进行图片的渲染
          img.onload = function() {
            //图片旋转压缩处理后的base64
            var compressedDataUrl =self.compress(img,self.fileData.type,self);
            //渲染到img标签上
            previewer.src = compressedDataUrl
            self.urlbase = compressedDataUrl
            img = null;
          };
          img.src = result;
        };
        reader.readAsDataURL(self.fileData);
      },
      //对图片进行旋转，压缩的方法，最终返回base64  渲染给img标签的src
      compress(img, fileType, self) {
        var degree=0,drawWidth,drawHeight,width,height;
        drawWidth=img.width;
        drawHeight=img.height;
        //以下改变一下图片大小
        var maxSide = Math.max(drawWidth, drawHeight);
        if (maxSide > 1024) {
          var minSide = Math.min(drawWidth, drawHeight);
          minSide = minSide / maxSide * 1024;
          maxSide = 1024;
          if (drawWidth > drawHeight) {
            drawWidth = maxSide;
            drawHeight = minSide;
          } else {
            drawWidth = minSide;
            drawHeight = maxSide;
          }
        }
        var canvas=document.createElement('canvas');
        canvas.width=width=drawWidth;
        canvas.height=height=drawHeight;
        var context=canvas.getContext('2d');

//        canvas.width=height;
//        canvas.height=width;
//        degree=90;
//        drawWidth=width;
//        drawHeight=-height;
//        context.rotate(degree*Math.PI/180);
//
//
        context.drawImage(img,0,0,drawWidth,drawHeight);
//        self.urlbase = img
        // 压缩0.5就是压缩百分之50
        var base64data = canvas.toDataURL(fileType, 0.5);
        canvas = context = null;
//        this.urlbase = base64data;
        return base64data;
      },
      pickerEvent (eventObj) {
        console.log(eventObj);
        this.showPiker = false;
        if (eventObj['selectData'] !== undefined) {
          this.userCurrentCity = eventObj.selectData
          this.addressCity = eventObj.addressCity
        }
      },
      base64toBlob(base64Data, contentType) {
        contentType = contentType || '';
        var sliceSize = 1024;
        var byteCharacters = atob(base64Data);
        var bytesLength = byteCharacters.length;
        var slicesCount = Math.ceil(bytesLength / sliceSize);
        var byteArrays = new Array(slicesCount);

        for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
          var begin = sliceIndex * sliceSize;
          var end = Math.min(begin + sliceSize, bytesLength);

          var bytes = new Array(end - begin);
          for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
          }
          byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        return new Blob(byteArrays, { type: contentType });
      }
    }
  }
</script>


<style lang="scss">
  @import '../../../assets/css/mixin';
  .userAccountSet-sparator {
    height: 1px;
    background-color: #d8d8d8;
    margin-left: pxToRem(52px);

  }

  .defaultAccountSet-cell {
    font-size: pxToRem(24px);
    margin-left: pxToRem(52px);
    margin-right: 0px;
    height: pxToRem(135px);
    display: flex;
    justify-content: space-between;
  }

  .defaultAccountSet-cell1 {
    height: pxToRem(220px);
  }

  .cell-rightView {
    margin-right: pxToRem(52px);
    text-align: right;
    line-height: pxToRem(135px);
  }
  .cell-rightView1 {
    line-height: pxToRem(220px);
    position: relative;
  }

  .cell-leftTitle {
    color: #BDBDBD;
    display: inline-block;
    height: pxToRem(135px);
    line-height: pxToRem(135px);
  }
  .cell-leftTitle1 {
    height: pxToRem(220px);
    line-height: pxToRem(220px);
  }

  #defaultAccountSet-userIcon {
    height: pxToRem(140px);
    width: pxToRem(140px);
    margin-top: pxToRem(40px);
    background-color: #EEEEEE;
  }

  #genderChoice1 {
    background-color: #4caf50;
    width: 50px;
    height: 50px;
  }
  #genderChoice2 {
    background-color: #4caf50;
    width: 50px;
    height: 50px;
  }
  #defaultAccountSet-cell-location {
    display: inline-block;
    width: pxToRem(18px);
    margin-left: pxToRem(20px);
    vertical-align: text-top;
  }

  input[type="file"] {
    color: transparent;
  }

  .upload-open-photo {
    opacity: 0;
    background-color: #26a2ff;
    position: absolute;
    left: 0px;
    width: pxToRem(140px);
    bottom: 0px;
    top: 0px;
  }

  .userAccountSet-textfield {
    text-align: right;
  }

  .sex-list {
    margin-top: 20px;
    margin-left: pxToRem(60px);
    li {
      line-height: pxToRem(64px);
      list-style-type:none;
      &:last-of-type {
        padding-left: pxToRem(30px);
      }
      float:left;
    }
  }

  .v-modal {
    background-color: #191919;
    opacity: 0.3;
  }

  .topHeard {
    padding: 0 pxToRem(30px);
    font-size: pxToRem(24px);

    .mint-header-title {
    }
    .mint-button-text {
      width: pxToRem(60px);
      display: inline-block;
    }
  }
</style>


// WEBPACK FOOTER //
// userAccountInfo.vue?6ae52cac